import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Lock, Eye, EyeOff } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const { toast } = useToast();

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Mock login - in a real app, this would authenticate with backend
    toast({
      title: 'Login functionality coming soon',
      description: 'This is a demo version. Authentication will be implemented in the full version.',
    });
  };

  return (
    <div className="min-h-screen bg-cream">
      <div className="min-h-screen flex items-center justify-center px-6 pt-20 pb-12">
        <div className="max-w-md w-full">
          {/* Login Card */}
          <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-10">
            <div className="text-center mb-8">
              <h1 className="font-serif text-4xl text-dark-green mb-3">Welcome Back</h1>
              <p className="text-dark-green/60">Log in to access your account</p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Email Field */}
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-dark-green mb-2"
                >
                  Email Address
                </label>
                <div className="relative">
                  <Mail
                    className="absolute left-4 top-1/2 -translate-y-1/2 text-dark-green/40"
                    size={20}
                  />
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full pl-12 pr-4 py-3 bg-cream border-2 border-dark-green/10 rounded-xl focus:border-dark-green focus:outline-none transition-colors duration-300"
                    placeholder="your@email.com"
                    required
                  />
                </div>
              </div>

              {/* Password Field */}
              <div>
                <label
                  htmlFor="password"
                  className="block text-sm font-medium text-dark-green mb-2"
                >
                  Password
                </label>
                <div className="relative">
                  <Lock
                    className="absolute left-4 top-1/2 -translate-y-1/2 text-dark-green/40"
                    size={20}
                  />
                  <input
                    type={showPassword ? 'text' : 'password'}
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full pl-12 pr-12 py-3 bg-cream border-2 border-dark-green/10 rounded-xl focus:border-dark-green focus:outline-none transition-colors duration-300"
                    placeholder="••••••••"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-4 top-1/2 -translate-y-1/2 text-dark-green/40 hover:text-dark-green transition-colors duration-300"
                  >
                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                  </button>
                </div>
              </div>

              {/* Forgot Password */}
              <div className="text-right">
                <button
                  type="button"
                  className="text-sm text-dark-green/60 hover:text-dark-green transition-colors duration-300"
                >
                  Forgot password?
                </button>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="w-full bg-dark-green text-cream py-3 rounded-xl font-medium hover:bg-dark-green/90 transition-all duration-300 hover:scale-105 shadow-lg"
              >
                Log In
              </button>
            </form>

            {/* Divider */}
            <div className="flex items-center gap-4 my-6">
              <div className="flex-1 h-px bg-dark-green/10"></div>
              <span className="text-sm text-dark-green/40">or</span>
              <div className="flex-1 h-px bg-dark-green/10"></div>
            </div>

            {/* Sign Up Link */}
            <div className="text-center">
              <p className="text-dark-green/60">
                Don't have an account?{' '}
                <Link
                  to="/apply"
                  className="text-dark-green font-medium hover:underline"
                >
                  Apply here
                </Link>
              </p>
            </div>
          </div>

          {/* Additional Info */}
          <div className="mt-8 text-center">
            <p className="text-dark-green/60 text-sm">
              By logging in, you agree to our Terms of Service and Privacy Policy
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
